import { Box, Grid, Typography, styled } from "@mui/material";

import DatePicker from "components/DatePicker";
import Select from "components/Select";
import useIsMobileView from "hooks/useIsMobileView";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function DateSort() {
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobileView = useIsMobileView();

  const portfolioForm = useSelector(
    (state) => state.portfolio.portfolioForm?.data
  );

  const portfolioDate = +searchParams.get("portfolioDate") || 0;
  const startDate = searchParams.get("startDate") || "";

  const handleChangeDate = (e) => {
    const value = e.target.value;

    const allSearchParams = Object.fromEntries([...searchParams]);

    const newSearchParams = {
      ...allSearchParams,
      portfolioDate: value,
    };

    delete newSearchParams?.startDate;

    setSearchParams(newSearchParams);
  };

  const handleChangeStartDate = (e) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      startDate: e,
    });
  };

  return (
    <Grid container mt={2} alignItems="center">
      <Grid item md={8} sm={6} xs={12}>
        <Typography variant={isMobileView ? "h6" : "h4"} color="text.main">
          Average Buy & Sell
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4} pt={isMobileView ? 1 : 0}>
        <BxDate>
          <Typography variant="subtitle1" mr={1} color="text.main">
            Date:
          </Typography>

          <SmallSelect
            items={portfolioForm?.lisDateType}
            itemValue="id"
            itemText="name"
            value={portfolioDate}
            onChange={handleChangeDate}
          />

          <BoxDatePicker>
            {portfolioDate === 5 && (
              <DatePicker value={startDate} onChange={handleChangeStartDate} />
            )}
          </BoxDatePicker>
        </BxDate>
      </Grid>
    </Grid>
  );
}

const SmallSelect = styled(Select)(({ theme }) => ({
  width: "auto",

  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 1),
    paddingRight: `${theme.spacing(3)} !important`,
    fontSize: "12px",
  },

  ".MuiButtonBase-root": {
    width: "16px",
    height: "16px",
    top: "50%",
    right: "2px",
    transform: "translateY(-50%)",
    padding: 0,
  },
}));

const BoxDatePicker = styled(Box)(() => ({
  marginLeft: "5px",
  ".MuiInputBase-input": {
    padding: "5px",
  },
}));

const BxDate = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-start",
  },
}));

export default DateSort;
